import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {tap} from 'rxjs/operators';
import {environment} from '../../environments/environment';
import {ProjectNote, ProjectNotesResponse} from '../../models/project/project-note';

@Injectable({providedIn: 'root'})
export class ProjectNoteService {
    private readonly httpClient = inject(HttpClient);
    private readonly notesChangedSubject = new Subject<ProjectNote[]>();

    /** Emits the updated notes whenever one is added, so note lists can refresh without a re-fetch. */
    public readonly notesChanged$ = this.notesChangedSubject.asObservable();

    public list(projectId: number): Observable<ProjectNote[]> {
        return this.httpClient.get<ProjectNotesResponse>(
            `${environment.apiUrl}/projects/${projectId}/notes`
        );
    }

    public create(projectId: number, message: string): Observable<ProjectNote[]> {
        return this.httpClient.post<ProjectNotesResponse>(
            `${environment.apiUrl}/projects/${projectId}/notes`,
            {message}
        ).pipe(
            tap((notes) => this.notesChangedSubject.next(notes))
        );
    }
}
